import {useQuery} from "@tanstack/react-query";
import {getInstantQuoteService} from "./index";

const fetchInstantQuote = async (
  productId?: string,
  latitude?: number,
  longitude?: number
): Promise<any> => {
  if (!productId) throw new Error("Product ID is required");
  if (!latitude) throw new Error("Latitude is required");
  if (!longitude) throw new Error("Longitude is required");
  try {
    const service = await getInstantQuoteService();
    return await service.get(productId, latitude, longitude);
  } catch (error: any) {
    // 404 is expected when site work cannot be determined for this location
    if (error?.response?.status === 404) {
      return null; // Return null to indicate no site work data available
    }
    
    // Log and throw other unexpected errors
    console.error("fetchInstantQuote", error);
    return null;
  }
};

function useInstantQuote(
  productId?: string,
  latitude?: number,
  longitude?: number
) {
  return useQuery<any[], Error>(
    ["instant-quote", productId, latitude, longitude],
    () => fetchInstantQuote(productId, latitude, longitude),
    {
      cacheTime: 0,
      enabled: Boolean(productId && latitude && longitude)
    }
  );
}

export default useInstantQuote;
